import { CartAddEvent } from '@theme/events';

// Global event delegation — handles dynamic content reliably
document.addEventListener('click', (event) => {
  const addUpsell = event.target.closest('.js-add-upsell');
  if (addUpsell) {
    handleAddUpsell(addUpsell);
    return;
  }
});

async function handleAddUpsell(addUpsell) {
  const variantId = addUpsell?.dataset.id;

  if (!variantId) {
    console.error('Upsell Product: Variant ID missing');
    return;
  }

  const spinner = addUpsell.querySelector('.spinner-wrapper');
  const plusIcon = addUpsell.querySelector('.icon-plus');

  // Show spinner, hide text
  if (spinner) spinner.hidden = false;
  if (plusIcon) plusIcon.hidden = true;

  try {
    // Add flow
    await refreshCart();

    await fetchJson('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    document.dispatchEvent(new CartAddEvent());


  } catch (error) {
    console.error('Upsell error:', error);
  } finally {
    // Hide spinner, show text
    if (spinner) spinner.hidden = true;
    if (plusIcon) plusIcon.hidden = false;
  }
}

async function fetchJson(url, options = {}) {
  const fetchOptions = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  };

  const response = await fetch(url, fetchOptions);
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`Fetch error ${response.status} on ${url}: ${errorText}`);
  }
  return response.json();
}

async function refreshCart() {
  try {
    await fetchJson('/cart.js');
  } catch (err) {
    console.warn('Cart refresh failed but continuing anyway:', err);
  }
}
